import type { CSSProperties } from 'react';
import { trackFeedbackClicked } from '../telemetry';

const WHATSAPP_NUMBER = '918975772486';

export const FEEDBACK_URL = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent('Hey! Feedback on BrainFart.fun: ')}`;

export function FeedbackLink({ from, style, variant = 'button' }: { from: string; style?: CSSProperties; variant?: 'button' | 'link' }) {
  if (variant === 'link') {
    return (
      <a href={FEEDBACK_URL} target="_blank" rel="noopener noreferrer" onClick={() => trackFeedbackClicked(from)} className="text-link" style={style}>
        Send feedback
      </a>
    );
  }
  return (
    <a
      href={FEEDBACK_URL}
      target="_blank"
      rel="noopener noreferrer"
      onClick={() => trackFeedbackClicked(from)}
      className="btn btn-ghost"
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '0.4rem',
        padding: '0.55rem 1.1rem',
        fontSize: '0.85rem',
        textDecoration: 'none',
        alignSelf: 'center',
        ...style,
      }}
    >
      💬 Send feedback on WhatsApp
    </a>
  );
}
